// Chosen as a value that is well below the max INTEGER db value of 2147483647,
// while still leaving room for Battle.net ids to grow.
export const CHINA_BNET_ID_PLACEHOLDER = 2_000_000_000;

export const checkIsChinaBNETId = (bnetId: number): boolean => {
  return bnetId >= CHINA_BNET_ID_PLACEHOLDER;
};

export type TChinaAudienceSignals = {
  countryCode?: string | null;
  isChinaAccount?: boolean | null;
  currentLocale?: string | null;
};

export function matchesChinaAudience({ countryCode, isChinaAccount, currentLocale }: TChinaAudienceSignals): boolean {
  return (
    countryCode?.trim().toUpperCase() === 'CN' ||
    isChinaAccount === true ||
    currentLocale?.trim().toLowerCase().split('-')[0] === 'zh'
  );
}
